import { ExternalService } from '@/constants/external-services'
import { useGetLicensesQuery } from '@/core/services/license'
import { useGetStaffQuery } from '@/core/services/staff'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { useAppSelector } from '@/redux/rootReducer'
import { isStaff } from '@/utils/type-guards'
import _ from 'lodash'

export const useReportLicenseEnabled = () => {
  const authUser = useAppSelector(selectAuthUser)
  const { data: licenses } = useGetLicensesQuery({ id: authUser?.licenses }, { skip: !authUser?.licenses.length })

  const services = _.uniq(_.flatten(licenses?.map((license) => license.services)))

  return isStaff(authUser) && services.includes(ExternalService.reports)
}

export const useReportLicenseEnabledForUser = (userId: string) => {
  const { data: user } = useGetStaffQuery(userId, { skip: !userId })
  const { data: licenses } = useGetLicensesQuery({ id: user?.licenses }, { skip: !user?.licenses?.length })

  const services = _.uniq(_.flatten(licenses?.map((license) => license.services)))

  return isStaff(user) && services.includes(ExternalService.reports)
}
